import React from 'react';
import PropTypes from 'prop-types';

export const Heading = (props) => {

    let HeadingSize = props.size;
    return(
      <div>
        {
          props.link ?
            <a href={props.link} target="_blank"> <HeadingSize className="kiwi-heading" style={props.style}>{props.content}</HeadingSize> </a>

            :
            <HeadingSize className="kiwi-heading" style={props.style}>{props.content}</HeadingSize>
        }
      </div>
    )
};

Heading.propTypes = {
  content: PropTypes.string,
  size: PropTypes.string,
};

Heading.defaultProps = {
  size: "h1"
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/Heading.js